(function () {
  if (!localStorage.getItem('clid')) {
    localStorage.setItem(
      'clid',
      'clid_' + crypto.randomUUID()
    );
  }
})();

function getFinalUrlWithClid() {
  const clid = localStorage.getItem('clid');
  const url = new URL(window.location.href);
  url.searchParams.set('clid', clid);
  return url.toString();
}

document.querySelector(".book-app--btn").addEventListener("click", openBookModal);
document.querySelector(".book-modal-close-btn").addEventListener("click", closeBookModal);

const bookModal = document.querySelector("#bookAppModal");
if (bookModal && bookModal.parentNode !== document.body) {
  document.body.appendChild(bookModal);
}

function openBookModal() {
  document.querySelector("#bookAppModal").classList.add('open');
}

function closeBookModal() {
  document.querySelector("#bookAppModal").classList.remove('open');
}

document.addEventListener("click", function(event) {
  const modal = document.querySelector("#bookAppModal");
  const modalContent = modal.querySelector(".modal-content"); 
  const bookButton = document.querySelector('.book-app--btn');

  if (!modalContent.contains(event.target) && event.target !== bookButton) {
    closeBookModal();
  }
});

  document.addEventListener("DOMContentLoaded", function () {
    var urlParams = new URLSearchParams(window.location.search);
    var contactPosted = urlParams.get('form_type');
    const form = document.querySelector('#book_app_modal');
    const successMessage = document.querySelector('.book-success-message');
    
    if (contactPosted === "contact") {    
    if (history.replaceState) {
            const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
        }
    } else {
        if (form) form.classList.remove("hidden");
        if (successMessage) successMessage.classList.add("hidden");
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  var urlParams = new URLSearchParams(window.location.search);
  const form = document.querySelector("#book_app_modal");
  const successMessage = document.querySelector('.book-success-message');
  var contactPosted = urlParams.get('form_type'); 
  
  if (!form) return;

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (form) form.classList.add("hidden");
    if (successMessage) successMessage.classList.remove("hidden");
    openBookModal();
    // Get form values
    const name = form.querySelector('input[name="contact[name]"]')?.value;
    const email = form.querySelector('input[name="contact[email]"]')?.value;
    const phone = form.querySelector('input[name="contact[phone]"]')?.value;
    const clid = localStorage.getItem('clid');
    const finalUrl = getFinalUrlWithClid();

    if (typeof gtag === 'function') {
      gtag('event', 'gtm.formSubmit', {
        event_category: 'Contact Form',
        event_label: 'Book Appointment Form',
        form_type: 'Contact',
        value: 1
      });      
    }

    // OR if using Google Tag Manager’s dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gtm.formSubmit',
      form_name: 'Book Appointment Form',
      form_type: 'Contact'
    });

    if (!window._klOnsite) {
      console.error("Klaviyo library not loaded.");
      return;
    }

    // Identify customer (optional, but recommended)
    _klOnsite.push([
      "identify",
      {
        $email: email,
        $first_name: name,
        $phone_number: phone,
        clid: clid,
        final_url: finalUrl
      },
    ]);

    // Track custom event
    _klOnsite.push([
      "track",
      "Book-Appointment(clid)",
      {
        submitted_at: new Date().toISOString(),
        email: email,
        first_name: name,
        phone_number: phone,
        clid: clid,
        final_url: finalUrl
      },
    ]);

    form.reset();
  });
});